import { APIRoute } from '@/modules/utils'
import { IRI } from 'emt-library'
import { ConversationMessage } from '@/dataV3/Conversation/ConversationMessage'

export const Route = (path: IRI): APIRoute => ({
  method: 'POST',
  path,
})

export type Body = {
  content: string
}

export type Response = ConversationMessage
